// extracted by mini-css-extract-plugin
module.exports = {"capycha-action":"src-pages-guide-component-province-validator-anhui-captcha-__index__capycha-action--2_zHp"};